import { ActionType, createAction } from 'typesafe-actions';

import InsurancePlan from '../../types/dto/InsurancePlan';

export const insurancePlanActions = {
  setInsurancePlan: createAction('@insurancePlan/SET')<InsurancePlan | undefined>()
};

export type InsurancePlanActions = ActionType<typeof insurancePlanActions>;
